import Image1 from '../images/siedziba-negativ-glowno.webp';

import '../css/headquarter.css';

import useDictionary from '../hooks/useDictionary';

export default function HeadQuarter() {

    const dictionary = useDictionary();

    return (
        <div className="hq-info">
            <div className="hq-photo default-hidden show-on-1400">
                <img alt="Negativ Headquarter in Glowno Poland" src={Image1} />
            </div>
            <div className="hq-content">
                <div className="sub-header">
                    {dictionary.HEAD_QUARTER}
                </div>
                <div className="header">
                    Made in Poland!
                </div>

                <div className="hide-on-1400">
                    <img alt="Negativ Headquarter in Glowno Poland" src={Image1} />
                </div>

                <div className="text">

                    <p>{dictionary.HEADQUARTER_P1}</p>
                    <p>{dictionary.HEADQUARTER_P2}</p>
                    
                </div>
                <div className="buttons">
                    <a href="https://www.google.com/maps/dir/?api=1&destination=NEGATIV+ul.+Dworska+27A+Głowno+Poland" target="_googlemaps" className="univ-button">{dictionary.GET_DIRECTIONS}</a>
                </div>
            </div>
        </div>
    )
}